// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"d135073c","864":"95a7770c","866":"0d146758"}[chunkId] + ".chunk.css";
};